// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"7a1f1fecf33e0af6","5405":"a01e511bd86f7525","6701":"a01e511bd86f7525","6898":"7cc963e551272a54"}[chunkId] + ".css";
};